export enum TipoPerfil {
    Usuario,
    Administrador
}